module.exports = __webpack_public_path__ + "static/Travel_Build_My_Book-230d7074116a9670e552cc062dbcb77b.jpg";